export const isFieldPresentInStrapi = (value: string | number) => value && value !== '_' && value !== ' ';
